export default function sofatutorWatermark(videojs) {
  videojs.registerPlugin('sofatutorWatermark', function() {
    var player = this;

    player.ready(function() {
      $(player.el()).append('<div class="vjs-upper-right-logo"></div>');
    });
  });
}
